import { MouseEvent } from 'react'

export const isButtonEvent = (evt: MouseEvent): boolean => {
  const target = evt.target as HTMLElement | null
  if (!target) return false
  return Boolean(target.closest('button'))
}
